import axios from 'axios';
import Auth from '@groovepages/gd-lib/auth';
import Swal from 'sweetalert2';
import store from '@/state';

// Request interceptor
axios.interceptors.request.use(request => {
    const { token } = Auth.authenticatedUser();

    if (token) {
        request.headers.common.Authorization = `Bearer ${token}`;
    }

    return request;
});

// Response interceptor
axios.interceptors.response.use(
    response => response,
    error => {
        const { status } = error.response;

        if (status >= 500) {
            Swal.fire({
                type: 'error',
                title: 'Error',
                text: 'Unknown Backend Error Occured. Please refresh and try again and if error persists, please contact support',
                reverseButtons: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancel'
            });
        }

        if (status === 401) {
            Swal.fire({
                type: 'warning',
                title: 'Login Expired',
                text: 'Session expired. Please login again',
                reverseButtons: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancel'
            }).then(() => {
                store.commit('logout');
                window.location.replace(`${window.config.grooveappsurl}/#/login`);
            });
        }

        return Promise.reject(error);
    }
);